import request from "@/utils/request";

// 查询用户签署的合同列表
export function getSignContractList(params) {
  return request({
    url: "/signature/getContractList",
    method: "get",
    params
  });
}
